<template>
<div class="card card-custom" v-loading="loading">
    <div class="card-header">
        <h3 class="card-title align-items-start flex-column py-3">
            <div class="d-flex align-items-center">
                <span class="card-label font-weight-bolder text-dark" v-text="title"></span>
                <span v-if="details.length!=0 && details.mstatus==1" class="svg-icon svg-icon-1 svg-icon-success"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A300"></path>
                        <path class="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white"></path>
                    </svg>
                </span>
                <div v-if="details.length!=0" :class="'btn btn-sm btn-light-'+details.param1+' ml-2 py-1 px-3'" ariadescribedby="el-popper-3403">{{details.nstatus}}</div>
            </div>
            <span class="text-muted font-weight-bold font-size-sm">Confirme su participando completando este formulario</span>
        </h3>
    </div>
    <div class="card-body">
        <div class="row p-5 mb-10 border border-secondary rounded border-dashed bg-gray-100">
            <div class="col-sm-4">
                <div class="font-weight-bold text-muted mb-1">Estado del formulario:</div>
                <div class="font-weight-bolder font-size-6" v-html="statusNameForm()"></div>
            </div>
            <!--statusNameForm()-->
            <div class="col-sm-4">
                <div class="font-weight-bold text-muted mb-1">Fecha de creación:</div>
                <div class="font-weight-bolder text-gray-800 d-flex align-items-center flex-wrap">
                    <span class="text-capitalize">{{$moment(form1.date_start).format("DD MMM YYYY")}}</span>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="font-weight-bold text-muted mb-1">Fecha de cierre:</div>
                <div class="font-weight-bolder text-gray-800 d-flex align-items-center flex-wrap">
                    <span class="text-capitalize pr-2">{{$moment(form1.date_end).format("DD MMM YYYY")}}</span>
                    <span class="text-danger d-flex align-items-center">
                        <!--<span class="bullet bullet-dot bg-danger mr-2"></span>Finaliza en 7 días--></span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6 d-flex justify-content-end">
                <div class="btn btn-sm btn-primary mr-3" @click="onRegister">Registrar</div>
                <div class="btn btn-sm btn-success" @click="finalizar">Enviar Participación</div>
            </div>
        </div>

        <el-tabs v-model="tab" @tab-click="handleClick">
            <el-tab-pane label="Deportistas" name="Deportistas">
                <el-table :data="dataDeportista" style="width: 100%">
                    <el-table-column prop="docnumber" label="Documento" width="180">
                    </el-table-column>
                    <el-table-column label="Participante" width="300">
                        <template #default="scope">
                            <div class="d-flex align-items-center">
                                <div class="symbol symbol-40 symbol-light-success mr-3">
                                    <el-avatar shape="square" size="large" fit="contain" :src="scope.row.photo" :class="'border-success'"></el-avatar>
                                </div>
                                <div class="text-dark-50 text-hover-primary" style="line-height:1.25">
                                    <span>{{scope.row.firstname}} </span><br>
                                    <span> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="birthday" label="Fecha Nacimiento">
                        <template #default="scope">
                            <span>{{$moment(scope.row.birthday).format("DD/MM/YYYY")}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Estado">
                        <template #default="scope">
                            <span class="badge bg-light-dark" v-if="scope.row.checkdoc == 0">Borrador</span>
                            <span class="badge bg-light-success" v-if="scope.row.checkdoc == 1">Activo</span>
                            <span class="badge bg-light-danger" v-if="scope.row.checkdoc == 2">Eliminado</span>
                            <span class="badge bg-light-warning" v-if="scope.row.checkdoc == 3">Enviado</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Opciones">
                        <template #default="scope">

                            <span v-if="scope.row.checkdoc == 0" class="svg-icon svg-icon-primary svg-icon-2x" @click="deleteItem(scope.row)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path d="M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z" fill="#000000" fill-rule="nonzero" />
                                        <path d="M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3" />
                                    </g>
                                </svg>
                            </span>
                        </template>
                    </el-table-column>

                </el-table>
            </el-tab-pane>
            <el-tab-pane label="Oficiales" name="Oficiales">
                <el-table :data="dataOficial" style="width: 100%">
                   <el-table-column prop="docnumber" label="Documento" width="180">
                    </el-table-column>
                    <el-table-column label="Participante" width="300">
                        <template #default="scope">
                            <div class="d-flex align-items-center">
                                <div class="symbol symbol-40 symbol-light-success mr-3">
                                    <el-avatar shape="square" size="large" fit="contain" :src="scope.row.photo" :class="'border-success'"></el-avatar>
                                </div>
                                <div class="text-dark-50 text-hover-primary" style="line-height:1.25">
                                    <span>{{scope.row.firstname}} </span><br>
                                    <span> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="functionName" label="Función">
                        
                    </el-table-column>
                    <el-table-column label="Estado">
                        <template #default="scope">
                            <span class="badge bg-light-dark" v-if="scope.row.checkdoc == 0">Borrador</span>
                            <span class="badge bg-light-success" v-if="scope.row.checkdoc == 1">Activo</span>
                            <span class="badge bg-light-danger" v-if="scope.row.checkdoc == 2">Eliminado</span>
                            <span class="badge bg-light-warning" v-if="scope.row.checkdoc == 3">Enviado</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Opciones">
                        <template #default="scope">

                            <span v-if="scope.row.checkdoc == 0" class="svg-icon svg-icon-primary svg-icon-2x" @click="deleteItem(scope.row)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path d="M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z" fill="#000000" fill-rule="nonzero" />
                                        <path d="M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3" />
                                    </g>
                                </svg>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

    </div>

    <el-dialog :title="'Registrar ' + tab" v-model="open_dialog_register" width="900px" top="3vh" @closed="onClosed">
        <el-form ref="refNominal" :model="form" status-icon :rules="rules" label-position="left" v-loading="loading">
            <div class="row">
                <div class="col-sm-9">
                    <div class="row mx-auto">
                        <div class="col-sm-4 border">
                            <el-form-item label="Nombres completos" prop="firstname" class="mt-0 mb-2">
                                <el-input v-model="form.firstname" size="small" maxlength="100"></el-input>
                                <!--<el-input v-model="formIntention.phonecode" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>-->
                            </el-form-item>
                        </div>
                        <div class="col-sm-4 border">
                            <el-form-item label="Apellido paterno" prop="lastname" class="mt-0 mb-2">
                                <el-input v-model="form.lastname" size="small" maxlength="100"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4 border">
                            <el-form-item label="Apellido materno" prop="surname" class="mt-0 mb-2">
                                <el-input v-model="form.surname" size="small" maxlength="100"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row mx-auto">
                        <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center px-2">Nacionalidad</div>
                        <div class="col-sm-5 border">
                            <el-form-item prop="nacionality" class="my-2">
                                <el-input v-model="form.nacionality" placeholder="Nacionalidad" size="small" maxlength="200"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Genero</div>
                        <div class="col-sm-3 border text-center">
                            <el-form-item prop="gender" class="my-2">
                                <el-radio-group v-model="form.gender" size="small">
                                    <el-radio :label="'M'" class="mb-0">M</el-radio>
                                    <el-radio :label="'F'" class="mb-0">F</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row mx-auto">
                        <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center px-2">F. Nacimiento</div>
                        <div class="col-sm-4 border">
                            <el-form-item prop="birthday" class="my-2">
                                <el-date-picker v-model="form.birthday" class="w-180px" size="small" type="date" placeholder="Seleccione" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6 border">
                            <el-form-item prop="place_of_birthday" class="mt-2 mb-2 w-100">
                                <el-input v-model="form.place_of_birthday" placeholder="Lugar de nacimiento" size="small" maxlength="200"></el-input>

                            </el-form-item>
                        </div>

                    </div>
                    <div class="row mx-auto">
                        <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center px-2">Pasaporte</div>
                        <div class="col-sm-4 border d-flex align-items-center">
                            <el-upload class="upload-demo" :headers="headers" name="file5" :action="action_file" accept=".jpg,.png,.pdf" :data="{tipo: 'file5', alias: 'PASSPORT'}" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                                <el-button size="small" type="success" plain>Clic para subir archivo</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        jpg/png/pdf archivos con un tamaño inferior a 1MB.
                                    </div>
                                </template>
                            </el-upload>
                        </div>
                        <div class="col-sm-6 border">
                            <el-form-item prop="pasaporte_number" label="Número de pasaporte" class="my-2">
                                <el-input v-model="form.pasaporte_number" size="small" maxlength="100"></el-input>
                            </el-form-item>
                            <el-form-item prop="pasaporte_expire" label="Fecha de expiración" class="my-2">
                                <el-date-picker v-model="form.pasaporte_expire" class="w-100" size="small" type="date" placeholder="Seleccione" />
                            </el-form-item>
                        </div>

                    </div>

                </div>
                <div class="col-sm-3 text-center">
                    <el-upload class="upload-demo" :headers="headers" name="file" action="https://sismaster.perufedup.com/api/photo/upload" accept=".jpg,.png" :data="{idperson: 0}" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                        <el-button size="small" type="success" plain>{{(idphoto==null) ? 'Clic para subir foto' : 'Clic para actualizar foto'}}</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                jpg/png archivos con un tamaño inferior a 1MB, fondo blanco, tamaño pasaporte.
                            </div>
                        </template>
                    </el-upload>
                    <el-image v-if="idphoto!=null" :src="photo.ruta" class="my-4 h-250px">
                        <template #placeholder class="image-slot">
                            cargando<span class="dot">...</span>
                        </template>
                    </el-image>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Teléfonos</div>
                <div class="col-sm-4 border">
                    <el-form-item label="Código del país" prop="phonecode" class="mt-0 mb-2">
                        <el-select v-model="form.phonecode" filterable placeholder="Seleccione" size="small">
                            <el-option v-for="item in callcodes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-sm-3 border">
                    <el-form-item label="#1" prop="phone1" class="mt-0 mb-2">
                        <el-input v-model="form.phone1" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-3 border">
                    <el-form-item label="#2" prop="phone2" class="mt-0 mb-2">
                        <el-input v-model="form.phone2" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">E-mail</div>
                <div class="col-sm-10 border">
                    <el-form-item prop="email" class="my-2">
                        <el-input v-model="form.email" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Peso (Kg)</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="peso" class="my-2">
                        <el-input v-model="form.peso" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Talla (cm)</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="talla" class="my-2">
                        <el-input v-model="form.talla" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Universidad</div>
                <div class="col-sm-5 border">
                    <el-form-item prop="university" class="my-2">
                        <el-input v-model="form.university" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
                <div v-if="tregister == 'D'" class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Código Matricula</div>
                <div v-if="tregister == 'D'" class="col-sm-3 border">
                    <el-form-item prop="codematricule" class="my-2">
                        <el-input v-model="form.codematricule" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>

            </div>
            <div v-if="tregister == 'D'" class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Facultad</div>
                <div class="col-sm-10 border">
                    <el-form-item prop="facultad" class="my-2">
                        <el-input v-model="form.facultad" size="small" maxlength="100"></el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Tipo de Registro</div>
                <div class="col-sm-3 border">
                    <el-form-item prop="tregister" class="my-2">
                        <el-select v-model="form.tregister" size="small">
                            <el-option v-if="tab=='Deportistas'" :label="tab" :value="'D'"></el-option>
                            <el-option v-else :label="tab" :value="'OF'"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="tab == 'Oficiales'" class="col-sm-4 border">
                    <el-form-item prop="toficial" class="my-2">
                        <el-select v-model="form.toficial" size="small" placeholder="Tipo de oficial" class="w-100" @change="form.idfunction=null">
                            <el-option :label="'Oficiales Tecnicos'" :value="'OT'"></el-option>
                            <el-option :label="'Oficiales Administrativos'" :value="'OA'"></el-option>
                            <el-option :label="'Oficiales Médicos'" :value="'OM'"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="tab == 'Oficiales' && form.toficial=='OT'" class="col-sm-3 border">
                    <el-form-item prop="idfunction" class="my-2">
                        <el-select v-model="form.idfunction" size="small" placeholder="Función">
                            <el-option :label="'Entrenador'" :value="'6'"></el-option>
                            <el-option :label="'Jefe De Equipo'" :value="'8'"></el-option>
                            <el-option :label="'Delegado Disciplina'" :value="'3'"></el-option>
                            <el-option :label="'Asistente Técnico'" :value="'13'"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="tab == 'Oficiales' && form.toficial=='OA'" class="col-sm-3 border">
                    <el-form-item prop="idfunction" class="my-2">
                        <el-select v-model="form.idfunction" size="small" placeholder="Función">
                            <el-option :label="'Presidente De Delegación'" :value="'7'"></el-option>
                            <el-option :label="'Delegado General'" :value="'4'"></el-option>
                            <el-option :label="'Presidente'" :value="'51'"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="tab == 'Oficiales' && form.toficial=='OM'" class="col-sm-3 border">
                    <el-form-item prop="idfunction" class="my-2">
                        <el-select v-model="form.idfunction" size="small" placeholder="Función">
                            <el-option :label="'Kinesiologo'" :value="'10'"></el-option>
                            <el-option :label="'Enfermero(a)'" :value="'12'"></el-option>
                            <el-option :label="'Apoyo Médico'" :value="'18'"></el-option>
                            <el-option :label="'Médico'" :value="'57'"></el-option>
                        </el-select>
                    </el-form-item>
                </div>

            </div>

            <div class="row mx-auto" v-if="tab == 'Deportistas'">
                <div class="col-sm-3 border bg-success-o-20 d-flex align-items-center">Ficha de elegibilidad</div>
                <div class="col-sm-9 border">
                    <div class="d-flex justify-content-between py-3">
                        <span v-if="idficha==null" class="border border-danger text-danger py-1 px-3 rounded w-100 mr-4">Falta subir archivo</span>
                        <span v-else class="border border-success text-success py-1 px-3 rounded w-100 mr-4">Archivo subido correctamente</span>
                        <a href="https://sismaster.perufedup.com/writable/uploads/docs/CertificadodeElegibilidad3x3.pdf" target="_blank" class="border bg-light-info border-info text-center w-250px rounded mr-3">Descargar archivo</a>
                        <el-upload class="upload-demo" :headers="headers" name="file1" :action="action_file" accept=".jpg,.png,.pdf" :data="{tipo: 'file1', alias: 'FEL'}" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                            <el-button size="small" type="success" plain>Clic para subir archivo</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-3 border bg-success-o-20 d-flex align-items-center">Certificado Médico</div>
                <div class="col-sm-9 border">
                    <div class="d-flex justify-content-between py-3">
                        <span v-if="idmedico==null" class="border border-danger text-danger py-1 px-3 rounded w-100 mr-4">Falta subir archivo</span>
                        <span v-else class="border border-success text-success py-1 px-3 rounded w-100 mr-4">Archivo subido correctamente</span>
                        <el-upload class="upload-demo" :headers="headers" name="file2" :action="action_file" accept=".jpg,.png,.pdf" :data="{tipo: 'file2', alias: 'CME'}" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                            <el-button size="small" type="success" plain>Clic para subir archivo</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-3 border bg-success-o-20 d-flex align-items-center">Seguro de viaje</div>
                <div class="col-sm-9 border">
                    <div class="d-flex justify-content-between py-3">
                        <span v-if="idseguro==null" class="border border-danger text-danger py-1 px-3 rounded w-100 mr-4">Falta subir archivo</span>
                        <span v-else class="border border-success text-success py-1 px-3 rounded w-100 mr-4">Archivo subido correctamente</span>
                        <el-upload class="upload-demo" :headers="headers" name="file3" :action="action_file" accept=".jpg,.png,.pdf" :data="{tipo: 'file3', alias: 'SVI'}" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                            <el-button size="small" type="success" plain>Clic para subir archivo</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-3 border bg-success-o-20 d-flex align-items-center">Carnet de vacunación {{idcarnet}}</div>
                <div class="col-sm-9 border">
                    <div class="d-flex justify-content-between py-3">
                        <span v-if="idcarnet==null" class="border border-danger text-danger py-1 px-3 rounded w-100 mr-4">Falta subir archivo</span>
                        <span v-else class="border border-success text-success py-1 px-3 rounded w-100 mr-4">Archivo subido correctamente</span>
                        <el-upload class="upload-demo" :headers="headers" name="file4" :action="action_file" accept=".jpg,.png,.pdf" :data="{tipo: 'file4', alias: 'CVA'}" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                            <el-button size="small" type="success" plain>Clic para subir archivo</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>

        </el-form>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="open_dialog_register = false" size="small">Cancelar</el-button>
                <el-button type="primary" size="small" @click="saveRegister('refNominal')">Guardar</el-button>
            </div>
        </template>

    </el-dialog>

</div>
</template>

<script>
import JwtService from "@/core/services/jwt.service";
//services
import acrService from '@/core/services/acr.service';
import code from "@/core/config/status.code";

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

import {
    mapGetters
} from "vuex";

export default {
    props: {
        title: {
            type: String,
            required: true,
            default: null
        },
        idevent: {
            type: String,
            required: true,
            default: null
        }
    },
    data: () => ({
        loading: false,
        tab: 'Deportistas',
        details: [],
        form1: {},
        finaliza: false,
        dataDeportista: [],
        dataOficial: [],
        open_dialog_register: false,
        idpasaporte: null,
        idphoto: null,
        photo: {},
        headers: {
            Authorization: `Bearer ${JwtService.getToken()}`
        },
        action_file: 'https://sismaster.perufedup.com/api/files/upload',
        idcarnet: null,
        idseguro: null,
        idmedico: null,
        idficha: null,

        form: {},
        rules: {
            firstname: [{
                required: true,
                message: "Se requiere nombres completos",
                trigger: ['blur', 'change']
            }],
            lastname: [{
                required: true,
                message: "Se requiere apellido paterno",
                trigger: ['blur', 'change']
            }],
            surname: [{
                required: true,
                message: "Se requiere apellido materno",
                trigger: ['blur', 'change']
            }],
            gender: [{
                required: true,
                message: "Se requiere género",
                trigger: ['blur', 'change']
            }],
            birthday: [{
                required: true,
                message: "Se requiere fecha de nacimiento",
                trigger: ['blur', 'change']
            }],
            pasaporte_number: [{
                required: true,
                message: "Se requiere número de pasaporte",
                trigger: ['blur', 'change']
            }],
            pasaporte_expire: [{
                required: true,
                message: "Se requiere fecha de expiración",
                trigger: ['blur', 'change']
            }],
            phonecode: [{
                required: true,
                message: "Se requiere código de llamada del país",
                trigger: ['blur', 'change']
            }],
            phone1: [{
                required: true,
                message: "Se requiere teléfono de oficina",
                trigger: ['blur', 'change']
            }],
            tregister: [{
                required: true,
                message: "Se requiere tipo de registro",
                trigger: ['blur', 'change']
            }],
            toficial: [{
                required: true,
                message: "Se requiere tipo de oficial",
                trigger: ['blur', 'change']
            }],
            idfunction: [{
                required: true,
                message: "Se requiere tipo de oficial",
                trigger: ['blur', 'change']
            }],

            peso: [{
                required: true,
                message: "Se requiere peso",
                trigger: ['blur', 'change']
            }],
            talla: [{
                required: true,
                message: "Se requiere talla",
                trigger: ['blur', 'change']
            }],
            university: [{
                required: true,
                message: "Se requiere talla",
                trigger: ['blur', 'change']
            }],
            codematricule: [{
                required: true,
                message: "Se requiere talla",
                trigger: ['blur', 'change']
            }],
            facultad: [{
                required: true,
                message: "Se requiere talla",
                trigger: ['blur', 'change']
            }],
            email: [{
                    required: true,
                    message: "Se requiere dirección de correo",
                    trigger: ['blur', 'change']
                },
                {
                    type: 'email',
                    message: "Ingrese un email válido",
                    trigger: ['blur', 'change']
                }
            ]
        }
    }),
    computed: {
        ...mapGetters(['callcodes']),
    },
    methods: {
        statusNameForm() {
            try {
                if (Object.keys(this.form1).length === 0)
                    return 'Información no disponible.';

                if (this.form1.mstatus == 'O') {
                    if (this.$moment(this.form1.date_end).diff(this.$moment()) > 0) {
                        this.finaliza = true;
                        return '<span class="text-primary">' + this.form1.nstatus + '</span>';
                    } else
                        return '<span class="text-danger">Cerrado para inscripción</span>'
                } else
                    return this.form1.nstatus;

            } catch (error) {
                return '<span class="text-warning">Información no disponible.</span>';
            }
        },
        onRegister() {
            this.open_dialog_register = true
        },
        saveRegister(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false;

                if (this.idpasaporte == null || this.idphoto == null || this.idcarnet == null || this.idseguro == null || this.idmedico == null) {
                    this.$alert('Tiene que subir toda la documentación', 'Documentación incompleta', {
                        type: 'warning'
                    });
                    return false
                }

                if (this.tab == 'Deportistas' && this.idficha == null) {
                    this.$alert('Falta subir la ficha de elegibilidad', 'Documentación incompleta', {
                        type: 'warning'
                    });
                    return false
                }

                this.onSave()
            });

        },
        async onSave() {
            try {
                this.loading = true;
                this.form.idphoto = this.idphoto;
                this.form.idcarnet = this.idcarnet;
                this.form.idseguro = this.idseguro;
                this.form.idmedico = this.idmedico;
                this.form.idficha = this.idficha;
                this.form.idpasaporte = this.idpasaporte;

                await acrService.guardarItemNominal(this.form).then((res) => {
                    if (res.data.status) {
                        this.$message.success(res.data.message);
                        this.open_dialog_register = false
                        this.loadData();
                    } else {
                        this.$message.error(res.data.message);
                    }
                }).catch((err) => {
                    this.loading = false;
                }).finally(() => {
                    this.loading = false
                });

                console.log(res.data.status)

            } catch (e) {
                this.loading = false;
                /*if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }*/
            }

        },
        onClosed() {
            this.idphoto = null;
            this.idcarnet = null;
            this.idseguro = null;
            this.idmedico = null;
            this.idficha = null;
            this.idpasaporte = null;
            this.$refs['refNominal'].resetFields();
        },
        handleAvatarSuccess(res, file) {
            switch (res.alias) {
                case 'CVA':
                    this.idcarnet = res.id
                    break;
                case 'SVI':
                    this.idseguro = res.id
                    break;
                case 'CME':
                    this.idmedico = res.id
                    break;
                case 'FEL':
                    this.idficha = res.id
                    break;
                case 'PASSPORT':
                    this.idpasaporte = res.id
                    break;
                case 'PHOTO':
                    this.idphoto = res.id
                    this.photo = res.photo
                    break;
            }
            this.loading = false
            this.$message({
                message: res.message,
                type: 'success'
            })
        },
        handleAvatarError(err, file) {
            this.loading = false
            const e = JSON.parse(err.message);
            this.$alert(e.messages.error, 'Error ' + e.error, {
                type: 'warning'
            });
        },
        beforeAvatarUpload(file) {
            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'application/pdf');

            if (!isIMAGE) {
                this.$message.error('Formato de archivo no admitido.');
                return false;
            }
            this.loading = true
            return true;
        },
        async loadData() {

            if (this.tab == 'Deportistas')
                this.tregister = 'D'
            else
                this.tregister = 'OF'

            this.loading = true
            await acrService.listarNominal({
                tregister: this.tregister
            }).then((res) => {
                this.form1 = res.data.config
                if (this.tregister == 'D') {
                    this.dataDeportista = res.data.payload
                } else {
                    this.dataOficial = res.data.payload
                }
            }).catch((err) => {
                this.loading = false
                this.$message.error('Se ha producio un error al procesar la información.');
            }).finally(() => {
                this.loading = false
            })
        },
        handleClick() {
            this.loadData();
        },
        deleteItem(data) {
            this.$confirm('Desea eliminar el registro de ' + data.firstname + '?', 'Aviso', {
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                this.onDelete(data)
            })
        },
        async onDelete(data) {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await acrService.deleteItem(data).then((res) => {
                if (res.data.status)
                    this.loadData()
                else
                    this.$alert(res.data.message, 'Aviso', {
                        type: 'error'
                    })
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        finalizar() {
            this.$confirm('Desea enviar la información de los participantes?', 'Aviso', {
                confirmButtonText: 'Si!, enviar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                this.onSendData()
            })
        },
        async onSendData() {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await acrService.finalizar().then((res) => {
                if (res.data.status)
                    this.loadData()
                else
                    this.$alert(res.data.message, 'Aviso', {
                        type: 'error'
                    })
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        }
    },
    created() {
        this.loadData()
    }
}
</script>
